// ============================================================
// DEALIN MVP - useAuth Hook
// ============================================================

import { useAuthStore } from '@/stores/authStore';

// Re-export useRegister for convenience
export { useRegister } from './useRegister';

/**
 * Main auth hook that provides auth state and actions
 * NOTE: L'inizializzazione avviene in App.tsx, non qui
 */
export const useAuth = () => {
  const {
    user,
    profile,
    vendor,
    isAuthenticated,
    isLoading,
    isInitialized,
    error,
    isVendor,
    isClient,
    unreadMessages,
    unreadNotifications,
    login,
    loginWithGoogle,
    logout,
    loadUserContext,
    clearError,
  } = useAuthStore();

  return {
    // State
    user,
    profile,
    vendor,
    isAuthenticated,
    isLoading,
    isInitialized,
    error,
    isVendor,
    isClient,
    unreadMessages,
    unreadNotifications,
    
    // Actions
    login,
    loginWithGoogle,
    logout,
    refreshContext: loadUserContext,
    clearError,
    
    // Computed
    displayName: user?.first_name || user?.username || 'User',
    companyName: profile?.company_name || vendor?.legal_name || '',
    avatarUrl: vendor?.logo || vendor?.logo_url || profile?.avatar || null,
  };
};

/**
 * Simple hook to check if user is authenticated
 * Use this for guards and conditional rendering
 */
export const useIsLoggedIn = () => {
  return useAuthStore((state) => state.isAuthenticated);
};

/**
 * Hook to get user type
 */
export const useUserType = () => {
  const isVendor = useAuthStore((state) => state.isVendor);
  const isClient = useAuthStore((state) => state.isClient);
  
  if (isVendor) return 'vendor';
  if (isClient) return 'client';
  return null;
};
